// 引入工具函数
import req from '@/utils/request';

export const getChannelList = (params) => {
  return req.get('/patient/ext/intent/channel-options', params);
}

export const getSysUserList = (params) => {
  return req.get('/system/user/empList', params);
}

export const getDoctorList = (params) => {
  return req.get('/system/user/doctorList', params);
}

export const getIntentTotal = (params) => {
  return req.get('/patient/ext/intent/total', params);
}

export const getIntentList = (params) => {
  return req.get('/patient/ext/intent/intent-list', params);
}

export const editIntent = (params) => {
  return req.post('/patient/ext/intent/addOrUpdate', params);
}

export const getIntentDetail = (params) => {
  return req.get('/patient/ext/intent/intent-patient', params);
}

export const getIntentHistory = (params) => {
  return req.get('/patient/ext/intent/history', params);
}